<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.bInvoices.totAmtPaid") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/pin.svg" width="90%" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>₦ {{ convertThousand(amountPaid) }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_dealer"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-6 text-center section___column_1">
                <h3 class="our__branches__banner__title">
                  {{ $t("text.bInvoices.payments") }}
                </h3>
              </div>
              <div class="col-md-6 text-right section___column_2">
                <div class="row align-items-center"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="table_align_div mt-3">
        <div class="">
          <div>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :allowTextWrap="true"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="paymentDate"
                  :headerText="t$('text.calendar.date')"
                ></e-column>
                <e-column
                  width="200"
                  field="amountPaid"
                  :headerText="`${$t('text.bInvoices.amt')} (${
                    branch ? branch.currencyCode : ''
                  }})`"
                ></e-column>
                <e-column
                  width="150"
                  field="paymentMethod"
                  :headerText="t$('text.bInvoices.paymentMtd')"
                ></e-column>
                <e-column
                  width="220"
                  field="note"
                  :headerText="t$('text.bInvoices.note')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import JQuery from "jquery";
import TableLoader from "@/components/tableLoader/index";

let $ = JQuery;
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  title: "Invoice Payments:: Epump Portal",
  name: "OurBranches",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      amountPaid: 0,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  mounted() {
    this.dealerId = this.$route.query.dealerId;
    this.getInvoiceDetails();

    $(".e-input").keyup((e) => {
      searchFun(e);
    });
    const searchFun = (event) => {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    };
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getInvoiceDetails() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/${this.$route.query.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.amountPaid = res.data.paymentDetails.reduce((total, cur) => {
            return total + cur.amountPaid;
          }, 0);

          res.data.paymentDetails.sort((a, b) => {
            return a.paymentDate > b.paymentDate
              ? -1
              : b.paymentDate > a.paymentDate
              ? 1
              : 0;
          });

          res.data.paymentDetails.forEach((cur, index) => {
            cur.index = index + 1;
            cur.amountPaid = this.convertThousand(cur.amountPaid);
            cur.paymentDate = this.$moment(cur.paymentDate).format(
              "DD MMMM YYYY"
            );
            cur.paymentMethod =
              cur.paymentMethod == 0
                ? "Bank Payment"
                : cur.paymentMethod == 1
                ? "Cash"
                : cur.paymentMethod == 2
                ? "Cheque"
                : cur.paymentMethod == 3
                ? "Credit Card"
                : "Other Methods";
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data.paymentDetails,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
